<template>
  <div
    class="message-item flex"
    :class="isCurrentUser ? 'justify-end' : 'justify-start'"
  >
    <!-- Avatar korisnika koji šalje poruku (prikazuje se samo za druge korisnike) -->
    <div v-if="!isCurrentUser" class="flex-shrink-0 mr-2">
      <div
        class="h-7 w-7 sm:h-8 sm:w-8 rounded-full bg-blue-600 flex items-center justify-center text-white text-xs"
      >
        {{ userInitial }}
      </div>
    </div>

    <div
      class="max-w-[85%] sm:max-w-xs md:max-w-md rounded-lg p-2 sm:p-3"
      :class="
        isCurrentUser
          ? 'bg-blue-600 text-white rounded-br-none'
          : 'bg-gray-700 text-white rounded-bl-none'
      "
    >
      <!-- Ime pošiljaoca (prikazuje se samo za druge korisnike) -->
      <div
        v-if="!isCurrentUser && message.sender"
        class="text-xs font-medium mb-1 text-blue-300"
      >
        {{ message.sender.username }}
      </div>

      <p class="text-sm sm:text-base break-words">{{ message.content }}</p>

      <div class="text-xs mt-1 opacity-70 flex justify-end items-center">
        {{ formatTime(message.createdAt) }}
        <span v-if="isCurrentUser" class="ml-1">
          <svg
            v-if="message.isRead"
            class="inline-block w-3 h-3 sm:w-4 sm:h-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <svg
            v-else
            class="inline-block w-3 h-3 sm:w-4 sm:h-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
            />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import { Message } from '@/types/chat-types';

export default defineComponent({
  name: 'MessageItem',
  props: {
    message: {
      type: Object as PropType<Message>,
      required: true,
    },
    isCurrentUser: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const formatTime = (dateString: string) => {
      const date = new Date(dateString);
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    };

    const userInitial = computed(() => {
      if (props.message.sender && props.message.sender.username) {
        return props.message.sender.username.charAt(0).toUpperCase();
      }
      return '?';
    });

    return {
      formatTime,
      userInitial,
    };
  },
});
</script>
